import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Table } from "react-bootstrap";


const AdminRegisterModal = () => {
  const [admins, setAdmins] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const response = await axios.get("https://agpipefitting.org.et/api/admin-register");
      setAdmins(response.data);
    } catch (error) {
      console.error("Error fetching admins:", error);
    }
  };

  const handleAdminAdded = () => {
    fetchAdmins(); // Refresh the admin list after adding a new admin
  };

  return (
    <div className="container mt-4">
      <h2>Admin Management</h2>
      <Button variant="primary" onClick={() => setShowModal(true)}>
        Add Admin
      </Button>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {admins.map((admin) => (
            <tr key={admin.id}>
              <td>{admin.id}</td>
              <td>{admin.name}</td>
              <td>{admin.email}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <AdminRegisterModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onAdminAdded={handleAdminAdded}
      />
    </div>
  );
};

export default AdminRegisterModal;
